import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

import GlobalTooltip from 'components/GlobalTooltip';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';
import { confirmDialog } from 'primereact/confirmdialog';
import useIsMobileView from 'hooks/useIsMobileView';
import { useWebSocketContext } from 'context/WebSocketConnectionContext';

export default function Table(props) {
  const { automationList, paginatorTemplate, pageSize, handleDuplicateAutomationRule, updateStatus } = props || {};
  const isMobileView = useIsMobileView();
  const websocketContext = useWebSocketContext();

  //DataTable Templates
  const titleTemplate = (rowData) => {
    return (
      <>
        <span className="p-column-title text-break">Title</span>
        <Link
          to={`/settings/workflow-automation/edit/${rowData?.automation_rule_id}`}
          className="cursor-pointer call-back text-bold text-decoration-none"
          title={rowData['workflow_title']}
        >
          {rowData['workflow_title']}
        </Link>
      </>
    );
  };

  const practiceAreaTemplate = (rowData) => {
    const { practice_area_names = [] } = rowData || {};
    return (
      <>
        <span className="p-column-title text-break">Practice Area</span>
        <span id={`paTooltip_`} title={practice_area_names?.join(' , ') || undefined}>
          {practice_area_names.length === 0 ? 'ALL' : practice_area_names?.join(' , ') || 'N/A'}
        </span>
      </>
    );
  };

  // const runningInstanceTemplate = (rowData) => {
  //   return (
  //     <>
  //       <span className="p-column-title text-break">Triggers when</span>
  //       <span title={rowData?.running_workflows ?? undefined}>{rowData?.running_workflows ?? 'N/A'}</span>
  //     </>
  //   );
  // };

  const triggersWhenTemplate = (rowData) => {
    return (
      <>
        <span className="p-column-title text-break">Triggers when</span>
        <span title={rowData?.workflow?.fire_on?.label || undefined}>{rowData?.workflow?.fire_on?.label || 'N/A'}</span>
      </>
    );
  };

  const errorLogsTemplate = (rowData) => {
    let showErrorAlertIcon = rowData?.is_error || websocketContext?.automationErrorLogData?.body?.automation_rule_pk === rowData?.pk;
    return (
      <>
        <span className="p-column-title text-break">Error Logs</span>
        <span className="d-inline-table">
          {showErrorAlertIcon ? (
            <GlobalTooltip tooltip="Error Log" position="top">
              <Link
                to={`/settings/workflow-automation/error-logs/${rowData?.automation_rule_id}`}
                className="cursor-pointer text-decoration-none F-size14 call-back"
              >
                <i className="icon-Alert pointer d-block" />
              </Link>
            </GlobalTooltip>
          ) : null}
        </span>
      </>
    );
  };

  const statusTemplate = (rowData) => {
    let isActiveAutomationRule = rowData?.automation_status === 'INACTIVE' ? false : true;
    return (
      <>
        <span className="p-column-title text-break">Status</span>
        <span className="d-inline-table">
          <div>
            <InputSwitch
              checked={isActiveAutomationRule}
              onChange={() => {
                if (isActiveAutomationRule) {
                  confirmDialog({
                    header: 'Confirm Changes',
                    message: 'All running instances will stop while updating. Do you want to proceed?',
                    icon: 'pi pi-exclamation-triangle',
                    acceptClassName: 'p-button-primary',
                    rejectClassName: 'p-button-secondary outline',
                    closable: false,
                    className: 'confirm-dialog',
                    accept: () => updateStatus(rowData),
                  });
                } else if (!isActiveAutomationRule) {
                  updateStatus(rowData);
                }
              }}
              className="input-swich"
            />
            <div className="text-hint mt-1 F-size11 ms-0">{rowData?.automation_status}</div>
          </div>
        </span>
      </>
    );
  };

  //This template can be used in future if any requirements are there
  const actionTemplate = (rowData) => {
    return (
      <>
        <span className="p-column-title text-break">Actions</span>
        <span className="d-inline-table">
          <GlobalTooltip tooltip="Duplicate" position="top">
            <i className="pi pi-clone pointer" style={{ fontSize: '1rem' }} onClick={() => handleDuplicateAutomationRule(rowData)}></i>
          </GlobalTooltip>
        </span>
      </>
    );
  };

  return (
    <ResizableDataTable
      value={automationList}
      paginator
      paginatorTemplate={paginatorTemplate}
      rows={pageSize}
      className="p-datatable-responsive"
      storageKey="column_widths_automation_list"
      stripedRows
      columns={[
        {
          header: 'Title',
          field: 'workflow_title',
          body: titleTemplate,
          sortable: true,
        },
        {
          header: 'Practice Area',
          field: 'practice_area_names',
          body: practiceAreaTemplate,
          sortable: true,
          className: 'ellipsis-text',
        },

        // {
        //   header: 'Instances',
        //   field: 'running_workflows',
        //   body: runningInstanceTemplate,
        //   sortable: false,
        // },
        {
          header: 'Triggers when',
          field: 'fire_on.label',
          body: triggersWhenTemplate,
          sortable: false,
        },
        {
          header: 'Errors',
          field: 'is_error',
          body: errorLogsTemplate,
          sortable: false,
          style: isMobileView ? {} : { textAlign: 'center' },
        },
        {
          header: 'Status',
          field: 'automation_status',
          body: statusTemplate,
          sortable: true,
        },
        {
          header: 'Actions',
          field: 'action',
          body: actionTemplate,
          sortable: false,
          fixed: true,
          width: '80px',
          resizable: false,
          style: isMobileView ? {} : { textAlign: 'center' },
        },
      ]}
    />
  );
}
